import React from "react";
import useDesktopMediaQuery from "hooks/useDesktopMediaQuery";
import { Shimmer } from "@my-scoot/component-library-legacy";

export const ThankYouPagesListItemCardShimmer = () => {
  const isDesktop = useDesktopMediaQuery();
  return isDesktop ? (
    <div className="tw-grid tw-grid-cols-[489fr_150fr_300fr] tw-gap-x-[10px] tw-bg-white tw-border-[1.5px] tw-border-solid tw-border-[#e7e6e4] tw-py-[24px] tw-px-[12px] tw-grid-flow-row first:tw-rounded-t-[4px] last:tw-rounded-b-[4px] last:tw-border-b-[3px]">
      <div className="d-flex align-items-center">
        <Shimmer height="66px" width="132px" borderRadius="5px" />
        <div className="ml-2">
          <Shimmer
            height="20px"
            width="120px"
            borderRadius="5px"
            wrapper_classname="mb-1"
          />
          <Shimmer height="16px" width="100px" borderRadius="5px" />
        </div>
      </div>
      <Shimmer
        height="26px"
        width="80px"
        borderRadius="5px"
        wrapper_classname="m-auto"
      />
      <Shimmer
        height="26px"
        width="80%"
        borderRadius="5px"
        wrapper_classname="my-auto ml-auto"
      />
    </div>
  ) : (
    <div className="tw-rounded-[5px] tw-border-[1.5px] tw-border-solid tw-border-[#e7e6e4] odd:tw-bg-white even:tw-bg-[#f7f7f7]">
      <div className="d-flex align-items-center justify-content-between px-2 py-3 border-bottom">
        <Shimmer height="14px" width="50%" borderRadius="8px" />
        <Shimmer height="14px" width="26px" borderRadius="8px" />
      </div>
      <div className="p-2 d-flex">
        <div className="mr-2">
          <Shimmer width="90px" height="90px" borderRadius="8px" />
        </div>
        <div className="d-flex flex-column w-100">
          <Shimmer height="9px" borderRadius="8px" wrapper_classname="mb-1" />
          <Shimmer width="50%" height="9px" borderRadius="8px" />
        </div>
      </div>
    </div>
  );
};
